import { RoadDetailInfo as L2RSegmentDetailInfo } from "@l2r-front/l2r-networks"
import { BottomSheetContent as UiBottomSheetContent, styled, styledForMobile } from "@l2r-front/l2r-ui"

export const RoadDetailInfo = styled(L2RSegmentDetailInfo)(({ theme }) => ({
    marginBottom: theme.spacing(6),
}))

export const BottomSheetContent = styledForMobile(UiBottomSheetContent)(({ isMobile, theme }) => ({
    padding: !isMobile && theme.spacing(5, 6, 0, 6),
}))